// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F4iD","select":"styles_select__3rjMd"};